import { Component } from '@angular/core';
import { ClientSelectionState } from '../../../state/ClientSelectionState/ClientSelection.state';
import { Store } from '@ngxs/store';
import { ClientTimeclockService } from '../../../services/client-timeclock.service';

@Component({
  selector: 'lib-connected-products-tile',
  templateUrl: './connected-products-tile.component.html',
  styleUrls: ['./connected-products-tile.component.css'],
  standalone: false
})
export class ConnectedProductsTileComponent {
  constructor(
    private store: Store,
    private clientTimeclockSerivce: ClientTimeclockService
  ) {}

  public linkToTimeclock() {
    this.store.selectOnce(ClientSelectionState.clientCode).subscribe(code => {
      this.clientTimeclockSerivce.openPortal(code).subscribe(url => {
        window.open(url, '_blank');
      });
    });
  }
}
